import { createContext } from "react";

const MeContext = createContext();

export default MeContext;
